<mat-menu #childMenu="matMenu" [overlapTrigger]="false" xPosition="before">
  <span *ngFor="let child of items">
    <!-- Handle branch node menu items -->
    <span *ngIf="child.children && child.children.length > 0" style="margin-top: 10px;">
      <button mat-menu-item color="primary" [matMenuTriggerFor]="menu.childMenu" #menuTrigger="matMenuTrigger"
        (click)="secondLevel(child.name,child.children)">
        <span class="item-block">
          <div class="item-name-icon">
            <img *ngIf="child.name==='Change Request'" src="../../assets/img/mail.png" alt="Change Request" width="20"
              height="20">
            <img *ngIf="child.name==='CAPA'" src="../../assets/img/prevention.svg" alt="CAPA" width="20" height="20">
            <img *ngIf="child.name==='Deviation'" src="../../assets/img/deviation.svg" alt="Deviation" width="20"
              height="20">
            <img *ngIf="child.name==='Audit'" src="../../assets/img/audit.svg" alt="Audit" width="20" height="20">
            <img *ngIf="child.name==='Incident'" src="../../assets/img/warning.png" alt="Incident" width="20"
              height="20">
            <img *ngIf="child.name==='Quality Issue'" src="../../assets/img/quality-control.png" alt="Quality Issue"
              width="20" height="20">
            <img *ngIf="child.name==='Customer Complaint'" src="../../assets/img/complain.png" alt="Customer Complaint"
              width="20" height="20">
            <img *ngIf="child.name==='Groups'" src="../../assets/img/people.png" alt="Customer Complaint" width="20"
              height="20">
            <img *ngIf="child.name==='Module'" src="../../assets/img/3d-design.png" alt="Customer Complaint" width="20"
              height="20">
            <img *ngIf="child.name==='User Trainings'" src="../../assets/img/business-presentation.png"
              alt="User Trainings" width="20" height="20">
            <img *ngIf="child.name==='Templates'" src="../../assets/img/windows.png" alt="Templates" width="20"
              height="20">
            <img *ngIf="child.name==='Notifications'" src="../../assets/img/notification.png" alt="Notifications"
              width="20" height="20">
            <img *ngIf="child.name==='Business Process'" src="../../assets/img/businessProcess.png"
              alt="Business Process" width="20" height="20">
            <!-- Add similar lines for other cases -->
          </div>&nbsp;
          <span>{{child.name}}</span>

        </span>

      </button>
      <app-menu-item #menu [items]="child.children"></app-menu-item>
    </span>
    <!-- Handle leaf node menu items -->
    <span *ngIf="!child.children || child.children.length === 0">
      <button mat-menu-item (click)="secondLevel(child.name,child.children)">
        <span class="item-block">
          <div class="item-name-icon">
            <img *ngIf="child.name==='My Trainings'" src="../../assets/img/teaching.png" alt="'My Trainings" width="20"
              height="20">
            <img *ngIf="child.name==='Manage Trainings'" src="../../assets/img/human-resources.png"
              alt="Manage Trainings" width="20" height="20">
            <img *ngIf="child.name==='Instructor Trainings'" src="../../assets/img/instructor.png"
              alt="Instructor Trainings" width="20" height="20">
            <img *ngIf="child.name==='Reports'" src="../../assets/img/analytics.png" alt="Reports" width="20"
              height="20">
            <img *ngIf="child.name==='Search'" src="../../assets/img/search.png" alt="Search" width="20" height="20">
            <img *ngIf="child.name==='Repository'" src="../../assets/img/folder.png" alt="Repository" width="20"
              height="20">
            <img *ngIf="child.name==='Manage'" src="../../assets/img/management.png" alt="Manage" width="20"
              height="20">
            <img *ngIf="child.name==='My Documents'" src="../../assets/img/documents.png" alt="My Documents" width="20"
              height="20">
            <img *ngIf="child.name==='Review'" src="../../assets/img/documents (1).png" alt="Review" width="20"
              height="20">
            <img *ngIf="child.name==='Issuance Tracking'" src="../../assets/img/tracking.png" alt="Issuance Tracking"
              width="20" height="20">
            <img *ngIf="child.name==='Destruction Tracking'" src="../../assets/img/tracking.png"
              alt="Destruction Tracking" width="20" height="20">
            <img *ngIf="child.name==='Master'" src="../../assets/img/programming.png" alt="Master" width="20"
              height="20">
            <img *ngIf="child.name==='Raise'" src="../../assets/img/talking.png" alt="Raise" width="20" height="20">
            <img *ngIf="child.name==='Forms Setup'" src="../../assets/img/formSetup.png" alt="Forms Setup" width="20"
              height="20">
            <img *ngIf="child.name==='Workflows'" src="../../assets/img/workflow.png" alt="Workflows" width="20"
              height="20">
            <img *ngIf="child.name==='Execution Setup'" src="../../assets/img/executionsetup.png" alt="Execution Setup"
              width="20" height="20">
            <img *ngIf="child.name==='Organization Profile'" src="../../assets/img/organization.png" alt="" width="20"
              height="20">
            <svg *ngIf="child.name === 'Printer'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
              viewBox="0 0 24 24" fill="none">
              <polyline points="6 9 6 2 18 2 18 9" stroke="#555555" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" stroke="#555555"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <rect x="6" y="14" width="12" height="8" stroke="#555555" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span *ngIf="child.name==='DR Mode'">
              <svg width="20" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.2998 22.347H5.49978C4.1743 22.347 3.09978 21.2725 3.09979 19.947L3.09989 5.54708C3.09989 4.2216 4.17441 3.14709 5.49989 3.14709H16.3002C17.6256 3.14709 18.7002 4.22161 18.7002 5.54709V12.1471M7.30017 7.94709H14.5002M7.30017 11.5471H12"
                  stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                <path
                  d="M11.588 19.8546L11.5991 19.3816L11.1666 19.5733C10.9949 19.6494 10.8098 19.6842 10.6274 19.673L10.6274 19.673L10.6239 19.6728C10.2997 19.6567 10.0057 19.5153 9.79258 19.2727L9.79084 19.2707C9.57624 19.0307 9.46827 18.7199 9.48675 18.3911C9.52702 17.7168 10.1057 17.1979 10.7711 17.2324C10.9312 17.2423 11.0816 17.2811 11.2178 17.3462L11.6363 17.5463L11.6471 17.0826L11.712 14.319L13.5874 14.3519L14.0263 14.3596L13.8741 13.9479C13.8216 13.806 13.7956 13.6542 13.7988 13.4974C13.8145 12.8264 14.375 12.2862 15.0467 12.2952C15.7136 12.3076 16.2425 12.8583 16.2266 13.5308C16.2206 13.6872 16.1871 13.8402 16.1281 13.9802L15.9559 14.3891L16.3996 14.3966L19.1929 14.4436L19.1215 17.3767C18.9089 17.2342 18.6616 17.1511 18.4032 17.1377L18.4029 17.1377C17.6098 17.0971 16.9287 17.7103 16.8807 18.507L16.8806 18.5074C16.8578 18.8946 16.9891 19.2646 17.2415 19.5503L17.2424 19.5513C17.4991 19.8393 17.8519 20.0104 18.2378 20.0306L18.2378 20.0306L18.2409 20.0307C18.5348 20.0431 18.8228 19.9685 19.0702 19.8151L19.0175 21.9649L16.0387 21.9139C16.1785 21.6922 16.2603 21.4356 16.2677 21.1703C16.2799 20.7815 16.135 20.4145 15.8675 20.137C15.6028 19.8605 15.2442 19.7037 14.8608 19.6943L14.8608 19.6943L14.859 19.6942C14.0638 19.6794 13.4015 20.3175 13.3809 21.1134C13.3735 21.3806 13.443 21.6416 13.573 21.8699L11.5417 21.835L11.588 19.8546Z"
                  stroke="black" stroke-width="1" />
              </svg>
            </span>
            <img *ngIf="child.name==='User Management'" src="../../assets/img/profile.png" alt="User Management"
              width="20" height="20">
            <img *ngIf="child.name==='Manage Menus'" src="../../assets/img/menu.png" alt="Manage Menus" width="20"
              height="20">
            <img *ngIf="child.name==='Vendors'" src="../../assets/img/provision.png" alt="Vendors" width="20"
              height="20">
            <img *ngIf="child.name==='Codelists'" src="../../assets/img/loading-bar.png" alt="Codelists" width="20"
              height="20">
            <i *ngIf="child.name==='Quality'" class="fas fa-certificate"></i>
            <i *ngIf="child.name==='Documents'" class="fas fa-folder-open"></i>
            <i *ngIf="child.name==='Trainings'" class="fas fa-chalkboard-teacher"></i>
            <img *ngIf="child.name==='Register'" src="../../assets/img/register.png" alt="Register" width="20"
              height="20">
            <img *ngIf="child.name==='Create'" src="../../assets/img/add.png" alt="Create" width="20" height="20">
            <img *ngIf="child.name==='Upgrade'" src="../../assets/img/upgrade.png" alt="Upgrade" width="20" height="20">
            <img *ngIf="child.name==='FlexiFields'" src="../../assets/img/flexibility.png" alt="FlexiFields" width="20"
              height="20">
            <img *ngIf="child.name==='Document Types'" src="../../assets/img/doc (1).png" alt="Document Types"
              width="20" height="20">
            <img *ngIf="child.name==='Schedulers'" src="../../assets/img/schedule.png" alt="Schedulers" width="20"
              height="20">
            <img *ngIf="child.name==='Training Review Period'" src="../../assets/img/magazine.png"
              alt="Training Review Period" width="20" height="20">
            <img *ngIf="child.name==='Product Master'" src="../../assets/img/new-product.png" alt="Product Master"
              width="20" height="20">
            <img *ngIf="child.name==='Business Areas'" src="../../assets/img/area-chart.png" alt="Business Areas"
              width="20" height="20">
            <img *ngIf="child.name==='Training Badge'" src="../../assets/img/certificate.png" alt="Training Badge"
              width="20" height="20">
            <img *ngIf="child.name==='Training Parameters'" src="../../assets/img/slider.png" alt="Training Parameters"
              width="20" height="20">
            <i *ngIf="child.name === 'Document Download'" class="fa fa-download fs-5 text-secondary">
            </i>

            <img *ngIf="child.name==='Training Certificates'" src="../../assets/img/certificate.png"
              alt="Training Certificates" width="20" height="20">
            <img *ngIf="child.name==='Forms and Logs'" src="../../assets/img/form.png" alt="Forms and Logs" width="20"
              height="20">
            <img *ngIf="child.name==='Feedback'" src="../../assets/img/feedback.png" alt="Feedback" width="20"
              height="20">
            <img *ngIf="child.name==='Reason for Signatures'" src="../../assets/img/signature.png"
              alt="Reason for Signatures" width="20" height="20">
            <img *ngIf="child.name==='Investigation Technique'" src="../../assets/img/investigation.png"
              alt="Investigation Technique" width="20" height="20">
            <img *ngIf="child.name==='Questionnaire'" src="../../assets/img/questionnaire.png" alt="Questionnaire"
              width="20" height="20">
            <img *ngIf="child.name==='Risk'" src="../../assets/img/warning (1).png" alt="Risk" width="20" height="20">
            <img *ngIf="child.name==='Location Master'" src="../../assets/img/location.png" alt="Location Master"
              width="20" height="20">
            <img *ngIf="child.name==='Document Report Headers'" src="../../assets/img/doc-header.png"
              alt="Document Report Header" width="20" height="20">
            <img *ngIf="child.name==='OOS/OOT Lab Investigation'" src="../../assets/img/laboratory.png"
              alt="Document Report Header" width="20" height="20">
            <img *ngIf="child.name==='Impact Assessment'" src="../../assets/img/impact.svg" alt="Document Report Header"
              width="20" height="20">
            <img *ngIf="child.name==='CheckList'" src="../../assets/img/check-list.svg" alt="Document Report Header"
              width="20" height="20">
            <img *ngIf="child.name==='Instrument Master'" src="../../assets/img/instrument.png" alt="Instrument"
              width="20" height="20">
          </div>&nbsp;
          <span>{{child.name}}</span>
        </span>

      </button>
    </span>
  </span>
</mat-menu>